module.exports = __webpack_public_path__ + "static/img/2.77f7c87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/2.png
// module id = D7um
// module chunks = 0